class KidsQuickShop extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.link = this.querySelector('a');
    this.link?.addEventListener('click', this.goToPurchase, { signal });
    window.addEventListener('scroll', this.queueUpdate, { passive: true, signal });
    window.addEventListener('resize', this.queueUpdate, { passive: true, signal });
    document.addEventListener('shopify:section:load', this.queueUpdate, { signal });
    this.queueUpdate();
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.resizeObserver?.disconnect();
    cancelAnimationFrame(this.frame);
  }

  findTarget() {
    if (!this.target?.isConnected) {
      this.resizeObserver?.disconnect();
      const id = this.dataset.revealSection;
      this.target = Array.from(document.querySelectorAll('[id^="shopify-section-"]'))
        .find(section => section.id.endsWith(`__${id}`));
      if (this.target) {
        this.resizeObserver = new ResizeObserver(this.queueUpdate);
        this.resizeObserver.observe(this.target);
        const consent = document.getElementById('shopify-pc__banner');
        if (consent) this.resizeObserver.observe(consent);
      }
    }
    return this.target;
  }

  queueUpdate = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      const target = this.findTarget();
      const consent = document.getElementById('shopify-pc__banner');
      const consentRect = consent?.getBoundingClientRect();
      const consentVisible = consentRect?.height > 0 && consentRect.top < window.innerHeight && getComputedStyle(consent).visibility !== 'hidden';
      this.style.setProperty('--sodii-quick-shop-dock-offset', `${consentVisible ? window.innerHeight - consentRect.top : 0}px`);
      const visible = Boolean(target && target.getBoundingClientRect().bottom <= 0);
      this.classList.toggle('is-visible', visible);
      this.setAttribute('aria-hidden', String(!visible));
      this.inert = !visible;
    });
  };

  goToPurchase = (event) => {
    const target = this.findTarget();
    const form = target?.querySelector('form[action*="/cart/add"]');
    if (!form) return; // Retain the product link if the opening section changes.
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    form.scrollIntoView({ behavior: reduceMotion ? 'instant' : 'smooth', block: 'center' });
    button?.focus({ preventScroll: true });
  };
}

if (!customElements.get('kids-quick-shop')) customElements.define('kids-quick-shop', KidsQuickShop);
